/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/kiosk`, controller.plan, makeLayout, render);
    router(`/dashboard/kiosk/edit`, controller.editPlan, makeLayout, render);
    router(`/dashboard/kiosk/subscribe`, controller.newPlan, makeLayout, render);
};
